import { render, staticRenderFns } from "./HomeworkTimeDeleteConfirmationDialog.vue?vue&type=template&id=01629cd8"
import script from "./HomeworkTimeDeleteConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./HomeworkTimeDeleteConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports